export default "__VITE_ASSET__2d689423__"